import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { SUBSCRIPTION_HEADER } from './LockedContent.constants';
import SubscribeMessage from './SubscribeMessage';
import styles from './LockedContent.module.scss';

const cx = classNames.bind(styles);

export interface LockedContentProps {
  title?: string;
  content?: ReactElement;
}

const LockedContent = ({ title, content }: LockedContentProps): ReactElement => (
  <div className={cx('body')} data-testid="locked-content">
    <div className={cx('header')}>{title ?? SUBSCRIPTION_HEADER}</div>
    <div className={cx('sub-header')}>{content ?? <SubscribeMessage />}</div>
  </div>
);

export default LockedContent;
